/**
 * Created by cl-macmini-34 on 18/09/17.
 */
App.controller('SettingCtrl',['$scope','$http','$location','ngDialog','$state','$timeout','$stateParams','Api','$loading',
    '$localStorage','toastr', 'userService', 'sessionService', 'ProfessionalService',
    function ($scope,$http,$location,ngDialog,$state,$timeout,$stateParams,Api,$loading,$localStorage,toastr, userService, sessionService, ProfessionalService) {

    $scope.nurseSettings = {};

    $scope.pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&.\^"%&'\(\)\+,-/:;<=>\[\\\]_`\{\|\}~])[A-Za-z\d$@$!%*#?&.\^"%&'\(\)\+,-/:;<=>\[\\\]_`\{\|\}~]{8,}$/;

    $scope.changePassword= async function(valid){
        if(valid){
            try {
                userService.changePassword($localStorage['token'], this.currentPassword, this.newPassword);
                toastr.success('Password changed successfully.');
                $state.reload();
            }catch (e) {
                toastr.error(e.message);
            }
        }
    };
    
    this.updateSettings = function(data){
        $scope.id = data._id;
        $scope.jobs = _.get(data,'jobs', {});
        $scope.nurseSettings.email = _.get(data, 'jobs.newJobEmail');
        $scope.nurseSettings.notification = _.get(data, 'jobs.newJobSms');
        $scope.nurseSettings.emailCommEnabled = _.get(data, 'emailCommunicationEnabled');
    }

   $scope.subscription = sessionService.professionalData.subscribe(this.updateSettings.bind(this));
   $scope.$on('$destroy', $scope.subscription);

    $scope.changeNotificationFlag = async function(){
        $loading.start('setting');
        const options = { 
            item: {
                jobs: {
                    newJobEmail: +$scope.nurseSettings.email,
                    newJobSms: $scope.nurseSettings.notification,
                },
                emailCommunicationEnabled: $scope.nurseSettings.emailCommEnabled
            }
        };
        
        try {
            await ProfessionalService.update($localStorage['token'], $scope.id, options);
            toastr.success('Notification preferences updated successfully');
            $scope.$emit('updateProfile');
        }catch (e){
            toastr.error(e.message);
        } finally {
            $loading.finish('setting');
        }
    }

}]);
